import { render, staticRenderFns } from "./noShowRecord.vue?vue&type=template&id=ff8cf722&scoped=true&"
import script from "./noShowRecord.vue?vue&type=script&lang=js&"
export * from "./noShowRecord.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff8cf722",
  null
  
)

export default component.exports